export default function(el, binding) {
    // Usage: <a v-utd-new-tab="someBoolean"
    const newTab = binding && typeof binding.value !== 'undefined'
        ? binding.value
        : true;
    if (newTab) {
        el.target = '_blank';
        el.rel = 'noopener noreferrer';
    }
}